import appConfig from 'app-config';
import store from 'src/stores';
import { nextPagePropsAtom } from 'src/stores/pageProps/atoms';
import type { SupportLanguage } from 'src/types/Language';

/**
 * API 서버 번역에 사용될 language code
 * ISO 639-1 언어코드 (영문2자리)
 */
export const getServerSideLanguageCode = () => {
  const webviewLocale = typeof window !== 'undefined' && window.AzarJs ? window.AzarJs.getUiLocale?.() : undefined;
  const pathLocale = store.get(nextPagePropsAtom)?.staticGenerationLanguage;
  const fallbackLocale = navigator.language;
  return (webviewLocale || pathLocale || fallbackLocale).substring(0, 2).toLowerCase();
};

/**
 * 웹 번역에 사용될 language code
 * ISO 639-1 언어코드 + ISO 3166 국가코드
 */
export const getClientSideLanguageCode = () => {
  const webviewLocale = typeof window !== 'undefined' && window.AzarJs ? window.AzarJs.getUiLocale?.() : undefined;
  const pathLocale = store.get(nextPagePropsAtom)?.staticGenerationLanguage;
  const fallbackLocale = navigator.language;
  return webviewLocale || pathLocale || fallbackLocale;
};

/**
 * ISO 3166 국가코드
 * 로그인 전 호출될 수 있는 api에서 서버 사이드 번역에 사용되는 정보.
 */
export const getClientSideCountryCode = () => {
  const languageCode = getClientSideLanguageCode();
  try {
    const bcp47 = languageCode.replace(/_/g, '-');
    return new Intl.Locale(bcp47).region?.toUpperCase();
  } catch {
    return undefined;
  }
};
const DEFAULT_LANGUAGE: SupportLanguage = 'en';
export const getLocale: () => SupportLanguage = () => {
  let userLanguage = getClientSideLanguageCode() as SupportLanguage;
  if (appConfig.supportedLanguages.includes(userLanguage)) {
    return userLanguage;
  }
  userLanguage = getServerSideLanguageCode() as SupportLanguage;
  if (appConfig.supportedLanguages.includes(userLanguage)) {
    return userLanguage;
  }
  return DEFAULT_LANGUAGE;
};